export default {
  path: '/profil_interface',
  name: 'profil_interfaces',
  component: () => import('../components/profilinterface/Layout'),
  redirect: { name: 'ProfilInterfaceList' },
  meta: {
    breadcrumb: 'administration.profil.profilinterfaces',
  },
  children: [
    {
      name: 'ProfilInterfaceList',
      path: '',
      component: () => import('../views/profilinterface/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfilInterfaceCreate',
      path: 'new',
      component: () => import('../views/profilinterface/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfilInterfaceShow',
      path: ':id',
      component: () => import('../views/profilinterface/Show'),
      meta: {
        breadcrumb: 'administration.profil.profilinterface',
      },
    },
    {
      name: 'ProfilInterfaceUpdate',
      path: ':id/edit',
      component: () => import('../views/profilinterface/Update'),
      meta: {
        breadcrumb: 'global.update',
      },
    },

  ]
};
